/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pearl_Tall_Seal_LiftInputs */

const en_pearl_tall_seal_lift = /** @type {(inputs: Pearl_Tall_Seal_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending`)
};

const de_pearl_tall_seal_lift = /** @type {(inputs: Pearl_Tall_Seal_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesendet`)
};

/**
* | output |
* | --- |
* | "Sending" |
*
* @param {Pearl_Tall_Seal_LiftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pearl_tall_seal_lift = /** @type {((inputs?: Pearl_Tall_Seal_LiftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pearl_Tall_Seal_LiftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pearl_tall_seal_lift(inputs)
	return de_pearl_tall_seal_lift(inputs)
});